import { useParams } from 'react-router';
import { PageNotFound } from '../../404';
import { IdlerFrontScreen } from './idler/FrontScreen';
import { IdlerRearScreen } from './idler/RearScreen';

export const IdlerFactoryScreen = () => {
  const { side } = useParams();

  switch (side) {
    case 'front':
      return <IdlerFrontScreen />;
    case 'rear':
      return <IdlerRearScreen />;
    default:
      return <PageNotFound />;
  }
};
